export function shouldResumeLifeFromTaskSnapshot({
  previousActiveTask,
  nextActiveTask,
  queuedTasks,
  world,
  lifeSim,
}) {
  if (nextActiveTask) {
    return false;
  }

  if (Array.isArray(queuedTasks) && queuedTasks.length > 0) {
    return false;
  }

  const snapshotMode =
    typeof world?.mode === 'string' && world.mode.trim().length > 0
      ? world.mode
      : null;
  if (snapshotMode && snapshotMode !== 'life') {
    return false;
  }

  const hasLingeringTaskText =
    typeof world?.current_task === 'string' && world.current_task.trim().length > 0;
  if (hasLingeringTaskText) {
    return false;
  }

  const hasLifeActivity =
    (typeof world?.activity === 'string' && world.activity.trim().length > 0) ||
    (typeof lifeSim?.last_act_id === 'string' && lifeSim.last_act_id.trim().length > 0);

  return !hasLifeActivity;
}

export function shouldResumeLifeFromRuntime({
  activeTask,
  queuedTasks,
  agent,
  lifeSim,
}) {
  if (activeTask) {
    return false;
  }

  if (Array.isArray(queuedTasks) && queuedTasks.length > 0) {
    return false;
  }

  if (!agent || agent.mode !== 'life') {
    return false;
  }

  const hasTaskText =
    typeof agent.currentTask === 'string' && agent.currentTask.trim().length > 0;
  if (hasTaskText) {
    return false;
  }

  const hasLifeActivity =
    (typeof agent.activity === 'string' && agent.activity.trim().length > 0) ||
    (typeof lifeSim?.lastActId === 'string' && lifeSim.lastActId.trim().length > 0);

  return !hasLifeActivity;
}
